import { usePasteConfig, type InputTableColumn } from '@/components/custom/erp';
import type { PasteResolverConfig } from '../../../types';

interface UseTaxPasteProps {
  columns: InputTableColumn[];
  handleUpdateNonWritableFields?: (fields: Set<string>) => void;
  handleUpdatePasteConfigs?: (configs: Record<string, PasteResolverConfig>) => void;
}

export const useTaxPaste = ({ columns, handleUpdateNonWritableFields, handleUpdatePasteConfigs }: UseTaxPasteProps) => {
  return usePasteConfig({
    columns,
    onNonWritableFields: handleUpdateNonWritableFields,
    onPasteConfigs: handleUpdatePasteConfigs
  });
};
